export const messages = {
  title: {
    id: 'admin/promotions.form.buy-and-win.title',
  },
  validation: {
    benefitEmpty: {
      id: 'admin/promotions.form.validation.benefit.empty',
    },
    triggerEmpty: {
      id: 'admin/promotions.form.validation.trigger.empty',
    },
    generic: {
      id: 'admin/promotions.form.group-box.validation.generic',
    },
  },
}
